import { AbstractConnector } from '@web3-react/abstract-connector';
import { ProviderType } from '@dcl/schemas';
import { getConfiguration } from '../configuration';
export class FortmaticConnector extends AbstractConnector {
    constructor(chainId) {
        const fortmaticConfiguration = getConfiguration()[ProviderType.FORTMATIC];
        const supportedChainIds = Object.keys(fortmaticConfiguration.apiKeys).map(key => Number(key));
        if (!supportedChainIds.includes(chainId)) {
            throw new Error(`Invariant error: Unsupported chainId ${chainId}`);
        }
        super({ supportedChainIds });
        this.apiKey = fortmaticConfiguration.apiKeys[chainId];
        this.chainId = chainId;
        this.rpcUrl = fortmaticConfiguration.urls[chainId];
    }
    async activate() {
        if (!this.fortmatic) {
            // @ts-ignore
            const { default: Fortmatic } = await import('fortmatic');
            this.fortmatic = new Fortmatic(this.apiKey, {
                rpcUrl: this.rpcUrl,
                chainId: this.chainId
            });
        }
        const account = await this.fortmatic
            .getProvider()
            .enable()
            .then((accounts) => accounts[0]);
        return {
            provider: this.fortmatic.getProvider(),
            chainId: this.chainId,
            account
        };
    }
    getApiKey() {
        return this.apiKey;
    }
    async getProvider() {
        return this.fortmatic.getProvider();
    }
    async getChainId() {
        return this.chainId;
    }
    async getAccount() {
        return this.fortmatic
            .getProvider()
            .send('eth_accounts')
            .then((accounts) => accounts[0]);
    }
    // tslint:disable-next-line
    deactivate() { }
    close() {
        return this.fortmatic.user.logout();
    }
}
//# sourceMappingURL=FortmaticConnector.js.map